'use client'
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export default function TwoCardGreenBgSlider({
   title,
   subTitle,
   TwoCardSlides,
}) {
   return (
      <section className="model_train_block2 section_primary_bg">
         <div className="container">
            <h2 className="section_heading_title faq-title">{title}</h2>
            <p className="faq-subtitle">{subTitle}</p>
         </div>

         <div className="position-relative">
            <div className="model_train_slider container-fluid position-relative">
               <Swiper
                  modules={[Navigation, Pagination]}
                  slidesPerView={2}
                  spaceBetween={30}
                  loop={true}
                  // navigation={{
                  //    nextEl: '.model_train_slider_custom_next_btn3',
                  //    prevEl: '.model_train_slider_custom_prev_btn3',
                  // }}
                  // centeredSlides={false}
                  // pagination={{
                  //    el: '.double_card_slider_green',
                  //    clickable: true,
                  //    renderBullet: (index, className) =>
                  //       `<span class="${className} custom-dark-bullet"></span>`,
                  // }}
                  navigation={{
                     nextEl: '.model_train_slider_custom_next_btn3',
                     prevEl: '.model_train_slider_custom_prev_btn3',
                  }}
                  centeredSlides={false}
                  pagination={{
                     el: '.fintach-pagination',
                     dynamicBullets: false,
                     clickable: true,
                     renderBullet: function (index, className) {
                        return `<span class="${className} custom-dark-bullet"></span>`
                     },
                  }}
                  breakpoints={{
                     320: {
                        slidesPerView: 1,
                        spaceBetween: 80,
                     },
                     769: {
                        slidesPerView: 1,
                        spaceBetween: 50,
                     },
                     1025: {
                        slidesPerView: 2,
                        spaceBetween: 60,
                     },
                  }}
                  className="model_train_slider container-fluid position-relative custom-slider-3"
               >
                  {TwoCardSlides.map((slide, idx) => (
                     <SwiperSlide key={idx}>
                        <div className="model-train-card">
                           <div className="icon-border text-center p-5 pb-0">
                              <div className="icon-border-svg">
                                 {slide.icon}
                              </div>
                           </div>
                           <div
                              className="model-train-card-desc"
                              style={{ padding: 35 }}
                           >
                              <h3
                                 className={`${
                                    slide.subHeading2 ? 'mb-0' : 'mb-4'
                                 }`}
                              >
                                 {slide.heading}
                              </h3>
                              {slide.subHeading ? (
                                 <h4 className="mb-3">{slide.subHeading}</h4>
                              ) : null}
                              {slide.subHeading2 ? (
                                 <p className="mb-3">{slide.subHeading2}</p>
                              ) : null}
                              <p>{slide.description}</p>
                           </div>
                        </div>
                     </SwiperSlide>
                  ))}
                  {/* <div className="d-flex justify-content-center mt-4 mt-md-0 gap-3 gap-md-0">
                     <div className="d-flex align-items-center justify-content-center">
                        <span className="d-flex align-items-center justify-content-center double_card_slider_green"></span>
                     </div>
                  </div> */}
               </Swiper>
            </div>
            <div className="d-flex justify-content-center slider-1-navigation-parent fintach_pagination_new_slider mt-2">
               <div className="model_train_slider_custom_prev_btn3 fintach_btn_new"></div>
               <div className="d-flex align-items-center justify-content-center">
                  <span className="d-flex align-items-center justify-content-center fintach-pagination"></span>
               </div>
               <div className="model_train_slider_custom_next_btn3 fintach_btn_new"></div>
            </div>
            {/* <div className="model_train_slider_custom_prev_btn3"></div>
            <div className="model_train_slider_custom_next_btn3"></div> */}
         </div>
      </section>
   )
}
